/** Texts for the tour of the app (first visit, and again from Hulp). Short sentences, no jargon. */
export const tourNl = {
  'tour.next': 'Volgende',
  'tour.back': 'Terug',
  'tour.skip': 'Overslaan',
  'tour.finish': 'Aan de slag',
  'tour.start': 'Rondleiding starten',
  'tour.startHint': 'In één minuut zie je waar alles staat.',
  'tour.progress': 'Stap {n} van {total}',
  'tour.welcome.title': 'Welkom bij KoalaSpot',
  'tour.welcome.body': 'We laten je in één minuut zien waar alles staat. Alles van je salon staat hier op één plek: je afspraken, je klanten en je instellingen.',
  'tour.today.title': 'Vandaag',
  'tour.today.body': 'Hier begin je elke dag. Je ziet wie er vandaag komt en wat je nog moet doen.',
  'tour.today.bodyStaff': 'Hier begin je elke dag. Je ziet jouw klanten van vandaag, op volgorde.',
  'tour.agenda.title': 'Agenda',
  'tour.agenda.body': 'Alle afspraken, per dag en per persoon. Tik op een leeg vakje om een afspraak te maken. Sleep een afspraak om hem te verzetten.',
  'tour.new.title': 'Nieuwe afspraak',
  'tour.new.body': 'Belt er een klant? Tik hier. Kies de klant, de dienst en een tijd. Klaar.',
  'tour.clients.title': 'Klanten',
  'tour.clients.body': 'Al je klanten, met telefoonnummer, eerdere afspraken en notities. Zoek op naam of nummer.',
  'tour.salon.title': 'Salon',
  'tour.salon.body': 'Wat je één keer instelt: je diensten en prijzen, je team, je openingstijden en online boeken.',
  'tour.share.title': 'Je boekingslink',
  'tour.share.body': 'Deel deze link via WhatsApp, Instagram of je website. Dan boeken klanten zelf, ook als jij aan het werk bent.',
  'tour.help.title': 'Hulp',
  'tour.help.body': 'Weet je iets even niet? Tik op het vraagteken. Daar staat uitleg, en daar start je deze rondleiding opnieuw.',
  'tour.done.title': 'Klaar!',
  'tour.done.body': 'Je weet nu waar alles staat. Alles wat je salon nodig heeft, vind je hier. Je hoeft niets anders bij te houden.',
  'tour.done.bodyStaff': 'Je weet nu waar alles staat. Je afspraken en klanten vind je altijd hier.',
};

export const tourEn: Record<keyof typeof tourNl, string> = {
  'tour.next': 'Next',
  'tour.back': 'Back',
  'tour.skip': 'Skip',
  'tour.finish': 'Get started',
  'tour.start': 'Start the tour',
  'tour.startHint': 'See where everything is in one minute.',
  'tour.progress': 'Step {n} of {total}',
  'tour.welcome.title': 'Welcome to KoalaSpot',
  'tour.welcome.body': "In one minute we'll show you where everything is. Everything about your salon is in one place: appointments, clients and settings.",
  'tour.today.title': 'Today',
  'tour.today.body': 'Start here every day. See who is coming today and what still needs doing.',
  'tour.today.bodyStaff': 'Start here every day. See your clients for today, in order.',
  'tour.agenda.title': 'Calendar',
  'tour.agenda.body': 'All appointments, per day and per person. Tap an empty slot to make an appointment. Drag an appointment to move it.',
  'tour.new.title': 'New appointment',
  'tour.new.body': 'A client calls? Tap here. Choose the client, the service and a time. Done.',
  'tour.clients.title': 'Clients',
  'tour.clients.body': 'All your clients, with phone number, past appointments and notes. Search by name or number.',
  'tour.salon.title': 'Salon',
  'tour.salon.body': 'What you set up once: services and prices, your team, opening hours and online booking.',
  'tour.share.title': 'Your booking link',
  'tour.share.body': 'Share this link on WhatsApp, Instagram or your website. Clients book themselves, even while you work.',
  'tour.help.title': 'Help',
  'tour.help.body': "Not sure about something? Tap the question mark. You'll find answers there, and you can start this tour again.",
  'tour.done.title': 'All set!',
  'tour.done.body': "You now know where everything is. Everything your salon needs is right here. There's nothing else to keep track of.",
  'tour.done.bodyStaff': 'You now know where everything is. Your appointments and clients are always here.',
};
